import * as React from "react";
import PageBreaker from "./PageBreaker";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import PageFooter from "./PageFooter";
import PageHeader from "./PageHeader";

const ModelConstDisclosureCoverPage = ({ portfolio }) => {
  return (
    <div className={"page cover-page model-disclosure"}>
      <PageHeader portfolio={portfolio} />
      <div className={"cover-page-shadow-top"} />
      <div className={"cover-page-shadow-bottom"} />
      <section className={"content"} data-toc="Model Constituent Disclosures">
        <Grid
          container={true}
          style={{ width: "8in", paddingLeft: "0.5in", paddingTop: "1in" }}
        >
          <Grid item xs={12} style={{ marginBottom: "1.5in" }}>
            <Typography variant={"h1"} style={{ marginBottom: "0.4in" }}>
              Cy Optimized Portfolio Summary
            </Typography>
            <Typography variant={"h2"}>
              Model Constituent Disclosures
            </Typography>
          </Grid>
        </Grid>
      </section>
      <PageFooter portfolio={portfolio} />
      <PageBreaker />
    </div>
  );
};

export default ModelConstDisclosureCoverPage;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/ModelConstDisclosureCoverPage.jsx